import NNLogoIcon from 'vectors/logo/logo-nationale-nederlanden.svg';
import VvcrProdriveIcon from 'vectors/logo/logo-vvcr.svg';
import LaadDirectIcon from 'vectors/logo/logo-laaddirect-2.svg';
import BedrijfswagenIcon from 'vectors/logo/logo-bda.svg';
import ZeroEIcon from 'vectors/logo/logo-zeroe.svg';
import WagenPartnersIcon from 'vectors/logo/logo-wagenpartners.svg';
import LeasePlanIcon from 'vectors/logo/logo-leaseplan-2.svg';
import HedinAutomotiveIcon from 'vectors/logo/logo-hedin.svg';

export const partners = [
  {
    name: 'Nationale Nederlanden',
    icon: NNLogoIcon,
    alt: 'nationale nederlanden',
    url: 'https://www.nn.nl/',
    id: 'image_nationale_nederlanden',
  },
  {
    name: 'VVCR-Prodrive',
    icon: VvcrProdriveIcon,
    alt: 'VVCR-Prodrive',
    url: 'https://vvcr-prodrive.nl/',
    id: 'image_vvcr_prodrive',
  },
  {
    name: 'Laad Direct',
    icon: LaadDirectIcon,
    alt: 'laad direct',
    url: 'https://laaddirect.nl/',
    id: 'image_laad_direct',
  },
  {
    name: 'De Bedrijfswagen Adviseurs',
    icon: BedrijfswagenIcon,
    alt: 'bedrijfswagen adviseur',
    url: 'https://www.debedrijfswagenadviseurs.nl/bedrijfswagen-leasen/?utm_source=referral&utm_medium=electifleet.nl&utm_campaign=bedrijfswagen_leasen',
    id: 'image_de_bedrijfswagen_adviseurs',
  },
  {
    name: 'Zero-E',
    icon: ZeroEIcon,
    alt: 'zero-e',
    url: 'https://www.zero-e.nl/',
    id: 'image_zero_e',
  },
  {
    name: 'Wagenpartners',
    icon: WagenPartnersIcon,
    alt: 'wagenpartners',
    url: 'https://www.wagenpartners.nl/',
    id: 'image_wagenpartners',
  },
  {
    name: 'LeasePlan',
    icon: LeasePlanIcon,
    alt: 'leaseplan',
    url: 'https://www.leaseplan.com/',
    id: 'image_leaseplan',
  },
  {
    name: 'Hedin Automotive',
    icon: HedinAutomotiveIcon,
    alt: 'hedin automotive',
    url: 'https://www.hedinautomotive.nl/nieuws/stern-wordt-hedin-automotive',
    id: 'image_hedin_automotive',
  },
];
